const ITEMS = [
  "Technology & Products",
  "Marketing & Growth",
  "Experiences & Wellbeing",
  "We build ventures",
  "We help brands grow",
];

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-white/[0.06] bg-deep/40 py-5" aria-hidden="true">
    <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center gap-10">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center gap-10 font-display text-sm font-medium uppercase tracking-[0.3em] text-slate-400">
              {item}
              <span className="h-1.5 w-1.5 rounded-full bg-teal/70" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
